/* Dansk katalog for locale-payroll-employees-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'pay.personalia': 'Personalia',
  'pay.personalInfo': 'Personoplysninger',
  'pay.edit': 'Redigér',
  'pay.documents': 'Dokumenter',
  'pay.description': 'Beskrivelse',
  'pay.contract': 'Ansættelseskontrakt',
  'pay.open': 'Åbn',
  'pay.download': 'Download',
  'pay.delete': 'Slet',
  'pay.employment': 'Ansættelsesforhold',
  'pay.positionAndAgreement': 'Stilling og aftale',
  'pay.searchOccupationCodes': 'Søg i stillingskoder ...',
  'pay.cancel': 'Annuller',
  'pay.saveEmployment': 'Gem ansættelsesforhold',
  'pay.employmentFrom': 'Ansættelsesforholdet gælder fra',
  'pay.employmentFromHint': 'Den dato, hvor medarbejderen havde, eller skal have, sin første arbejdsdag i din virksomhed. Datoen er uafhængig af, hvornår du begyndte at føre regnskab i Plumme.',
  'pay.endDate': 'Slutdato',
  'pay.endDateHint': 'Lad feltet stå tomt, når ansættelsesforholdet stadig er åbent.',
  'pay.occupationCode': 'Stillingskode',
  'pay.occupationCodeHint': 'Søg i det offentlige register over stillingskoder, og vælg den, der passer bedst. Feltet bruges til statistik over erhverv i Norge.',
  'pay.employmentType': 'Type af ansættelsesforhold',
  'pay.employmentForm': 'Ansættelsesform',
  'pay.workingHoursScheme': 'Arbejdstidsordning',
  'pay.workingHoursSchemeHint': 'De fleste medarbejdere har Ikke skiftarbejde, men nogle vil også høre under de andre kategorier.',
  'pay.hoursFullWeek': 'Timer for fuld uge',
  'pay.salaryType': 'Løntype',
  'pay.hourlyPay': 'Timeløn',
  'pay.fixedPay': 'Fast løn',
  'pay.ftePercent': 'Stillingsprocent',
  'pay.ftePercentHint': 'Vælg en anslået stillingsprocent. Er du usikker, så angiv den nærmeste procent.',
  'pay.fullTime': 'Fuldtid',
  'pay.partTime': 'Deltid',
  'pay.employmentScope': 'Stillingens omfang',
  'pay.adjustHoursBy': 'Justér timer efter',
  'pay.perWeek': 'Pr. uge',
  'pay.perMonth': 'Pr. måned',
  'pay.hoursPerWeek': 'Timer pr. uge',
  'pay.hoursPerMonth': 'Timer pr. måned',
  'pay.otherEntityNumber': 'Andet virksomhedsnummer',
  'pay.optionalEntityNumber': 'Valgfrit virksomhedsnummer',
  'pay.priorPayOutsidePlumme': 'Tidligere løn uden for Plumme udbetalt fra din virksomhed',
  'pay.priorPayHelp': 'Udfyld kun løn, der ikke er registreret i Plumme, men som er udbetalt af virksomheden.',
  'pay.warning': 'Advarsel:',
  'pay.forPublicStatistics': 'Til offentlig statistik - udfyldes kun, hvis det er relevant',
  'pay.lastAdjustmentDate': 'Dato for seneste lønregulering',
  'pay.salaryGrade': 'Løntrin',
  'pay.salaryGradePh': 'F.eks. 45',
  'pay.agreedSalary': 'Aftalt løn',
  'pay.save': 'Gem',
  'pay.annualSalary': 'Årsløn',
  'pay.agreementTaxHeading': 'Aftale, feriepenge, skat og arbejdsgiverafgift',
  'pay.tax': 'Skat',
  'pay.notFetchedFromAltinn': 'Ikke hentet fra Altinn',
  'pay.salaryPerYear': 'Løn pr. år',
  'pay.holidayPay': 'Feriepenge',
  'pay.employerContribution': 'Arbejdsgiverafgift',
  'pay.estimatedTax': 'Anslået skat',
  'pay.estimatedAnnualCost': 'Anslået årlig omkostning',
  'pay.noAgreedSalary': 'Der er ikke indtastet nogen aftalt løn',
  'pay.taxCard': 'Skattekort',
  'pay.taxCardHelp': 'Skattekort hentes ikke endnu. Det tilknyttes, når integrationen med Skatteetaten er klar.',
  'pay.fixedLines': 'Faste linjer',
  'pay.fixedLinesHelp': 'Lønlinjer, der normalt indgår i hver lønudbetaling.',
  'pay.newFixedLine': 'Opret ny fast linje',
  'pay.seeFixedLines': 'Se faste lønlinjer',
  'pay.payslips': 'Lønsedler',
  'pay.noPayslips': 'Der er endnu ikke lavet nogen lønsedler.',
  'pay.gross': 'Brutto',
  'pay.paidOut': 'Udbetalt',
  'pay.employeePortal': 'Medarbejderportal',
  'pay.employeePortalSub': 'Lønsedler, rejser og udlæg for medarbejderen.',
  'pay.needEmailFirst': 'Angiv en gyldig e-mailadresse på medarbejderprofilen, før du giver adgang.',
  'pay.goToTravelExpenses': 'Gå til rejser og udlæg',
  'pay.saveEmployee': 'Gem medarbejder',
  'pay.nationalId': 'Personnummer',
  'pay.hasInternationalId': 'Har internationalt ID',
  'pay.name': 'Navn',
  'pay.phone': 'Telefonnummer',
  'pay.email': 'E-mail',
  'pay.address': 'Adresse',
  'pay.country': 'Land',
  'pay.address1': 'Adresse 1',
  'pay.streetAddress': 'Gadeadresse',
  'pay.address2': 'Adresse 2',
  'pay.optional': 'Valgfrit',
  'pay.postalCode': 'Postnummer',
  'pay.postalPlace': 'By',
  'pay.postalPlacePh': 'By ...',
  'pay.accountNumber': 'Kontonummer',
  'pay.hasForeignAccount': 'Har udenlandsk kontonummer',
  'pay.mainOrSecondaryEmployer': 'Bi-/hovedarbejdsgiver',
  'pay.taxAndDutyRules': 'Skatte- og afgiftsregler',
  'pay.noteOptional': 'Note (valgfrit)',
  'pay.notePh': 'Skriv en note ...',
  'pay.employees': 'Medarbejdere',
  'pay.employeesHelp': 'Registret over alle medarbejdere i virksomheden. Tryk på en medarbejder for at se personalia, ansættelsesforhold, løn og lønsedler.',
  'pay.allEmployees': 'Alle medarbejdere i din virksomhed',
  'pay.newEmployee': 'Ny medarbejder',
  'pay.newEmployeeHelp': 'Registrér en ny medarbejder med personalia, ansættelsesforhold og lønvilkår. Medarbejderen kommer så med i lønkørsler og a-meldingen.',
  'pay.noEmployees': 'Ingen medarbejdere endnu',
  'pay.salaryTypeLabel': 'Løntype:',
  'pay.status': 'Status',
  'pay.statusHelp': 'Aktivt ansættelsesforhold betyder, at medarbejderen medtages i lønkørsler. Afsluttet betyder, at ansættelsesforholdet er ophørt.',
  'pay.payroll': 'Løn',
  'pay.payrollSub': 'Kør løn, følg op på medarbejdere, terminer og feriepenge.',
  'pay.payrollModuleHelp': 'Lønmodulet samler alt om medarbejdere og løn: lønkørsel, arbejdsgiverafgift og skattetræk, pension (OTP), feriepenge, rejser og udlæg samt indstillinger. Skift mellem undersiderne i rullemenuen.',
  'pay.payrollPages': 'Lønsider',
  'pay.payrollPagesHelp': 'Skift mellem undersiderne i løn — Medarbejdere, Lønudbetaling, Arbejdsgiverafgift og skat, Pension/OTP, Faste lønlinjer, Rejser og udlæg, Lønoversigt, Feriepengeliste, Lønindstillinger og Løntyper.',
  'pay.employmentStatus': 'Ansættelsesforhold',
  'pay.employmentStatusHelp': 'Viser, om ansættelsesforholdet er aktivt eller afsluttet. Aktive medarbejdere medtages i lønkørsler og indberettes i a-meldingen.',
  'pay.backToPayrollRun': 'Tilbage til lønudbetaling',
  'pay.showAllEmployees': 'Vis alle medarbejdere',
  'pay.yourEmployers': 'Dine arbejdsgivere',
  'pay.yourClients': 'Dine klienter',
  'pay.bgForEmployer': 'Baggrundsfarve for denne arbejdsgiver',
  'pay.bgColour': 'Baggrundsfarve',
  'pay.receiptHelp': 'Tag et billede, upload, træk ind eller indsæt. Udlæg uden bilag kan ikke indsendes.',
  'pay.takePhoto': 'Tag billede',
  'pay.uploadFile': 'Upload billede/fil',
  'pay.remove': 'Fjern',
  'pay.registerExpense': 'Registrér udlæg',
  'pay.receiptRequired': 'Bilag kræves',
  'pay.category': 'Kategori',
  'pay.pickCategory': 'Vælg kategori',
  'pay.date': 'Dato',
  'pay.paidWith': 'Betalt med',
  'pay.privateExpense': 'Privat udlæg',
  'pay.companyCard': 'Firmakort/driftskonto',
  'pay.amount': 'Beløb',
  'pay.currency': 'Valuta',
  'pay.whatIsExpenseFor': 'Hvad vedrører udlægget?',
  'pay.registerTravel': 'Registrér rejse',
  'pay.sentForApproval': 'Sendes til godkendelse',
  'pay.dateFrom': 'Dato fra',
  'pay.dateTo': 'Dato til',
  'pay.travelType': 'Rejsetype',
  'pay.travelWithExpenses': 'Rejse med udlæg/kørsel',
  'pay.drivingOnly': 'Kun kørsel',
  'pay.travelWithSubsistence': 'Rejse med diæter',
  'pay.destination': 'Rejsemål',
  'pay.destinationPh': 'By, kunde eller sted',
  'pay.from': 'Fra',
  'pay.startPlace': 'Startsted',
  'pay.to': 'Til',
  'pay.endPlace': 'Bestemmelsessted',
  'pay.kilometres': 'Kilometer',
  'pay.purpose': 'Formål',
  'pay.purposeHelp': 'Hvad var formålet med rejsen?',
  'pay.note': 'Note',
  'pay.createTravelClaim': 'Opret rejseafregning',
  'pay.purposePh': 'F.eks. kundemøde i Drammen',
  'pay.whereDidYouGo': 'Hvor gik rejsen hen?',
  'pay.norway': 'Norge',
  'pay.tolls': 'Vejafgifter',
  'pay.tollsPaidWith': 'Vejafgift betalt med',
  'pay.fromDate': 'Fra dato',
  'pay.toDate': 'Til dato',
  'pay.type': 'Type',
  'pay.hotel': 'Hotel',
  'pay.otherAccommodation': 'Anden overnatning',
  'pay.guesthouse': 'Pensionat eller barak',
  'pay.place': 'Sted',
  'pay.hotelOrPlace': 'Hotel eller sted',
  'pay.travelClaim': 'Rejseafregning',
  'pay.rejectedByEmployer': 'Afvist af arbejdsgiver',
  'pay.newAccommodation': 'Ny overnatning',
  'pay.newTrip': 'Ny køretur',
  'pay.newExpense': 'Nyt udlæg',
  'pay.noLinesYet': 'Ingen linjer endnu',
  'pay.employee': 'Medarbejder',
  'pay.subsistence': 'Diæter',
  'pay.payslip': 'Lønseddel',
  'pay.close': 'Luk',
  'pay.netPaid': 'Netto udbetalt',
  'pay.period': 'Periode',
  'pay.payAndDeductions': 'Løn og fradrag',
  'pay.grossPay': 'Bruttoløn',
  'pay.withholdingTax': 'Skattetræk',
  'pay.expenseRefund': 'Refusion udlæg/rejse',
  'pay.payslipPdfNote': 'PDF-visning og afsendelse tilknyttes, når lønseddelgeneratoren gøres tilgængelig i Plumme.',
  'pay.noPayslipsYet': 'Ingen lønsedler endnu.',
  'pay.myExpenses': 'Mine udlæg',
  'pay.noExpensesInView': 'Ingen udlæg i denne visning.',
  'pay.expenses': 'Udlæg',
  'pay.preview': 'Forhåndsvis',
  'pay.loadingReceipt': 'Indlæser bilag...',
  'pay.canStillDownload': 'Bilaget kan stadig downloades manuelt.',
  'pay.cannotPreview': 'Denne filtype kan ikke forhåndsvises her.',
  'pay.openNewTab': 'Åbn i ny fane',
  'pay.myTravel': 'Mine rejser',
  'pay.noTravelInView': 'Ingen rejser i denne visning.',
  'pay.fetchingPortal': 'Henter medarbejderportalen',
  'pay.portalFailed': 'Kunne ikke hente medarbejderportalen',
  'pay.back': 'Tilbage',
  'pay.noEmployers': 'Ingen arbejdsgivere',
  'pay.home': 'Hjem',
  'pay.homeHelp': 'Din medarbejderside hos den valgte arbejdsgiver — lønsedler, udlæg og rejser.',
  'pay.myPage': 'Min side',
  'pay.myPageHelp': 'Din personlige konto i Plumme — profil, virksomheder og privatøkonomi.',
  'pay.signOut': 'Log ud',
  'pay.paidByCompanyHint': 'Bilaget sendes til bogføring, ikke til refusion.',
  'pay.paidPrivateHint': 'Du får beløbet refunderet sammen med lønnen.',
  'pay.expenseProject': 'Projekt',
  'pay.expenseProjectHint': 'Udlæg på et projekt kan viderefaktureres til kunden.',
  'pay.expenseNoProject': 'Ikke på projekt',
  'pay.myHours': 'Mine timer',
  'pay.hoursThisMonth': '{time} denne måned',
  'pay.hoursHelp': 'De timer, du har registreret på projekter for denne arbejdsgiver.',
  'pay.registerHours': 'Registrer timer',
  'pay.timeNew': 'Registrer timer',
  'pay.timeEdit': 'Ret registrering',
  'pay.timeDate': 'Dato',
  'pay.timeProject': 'Projekt',
  'pay.timeActivity': 'Aktivitet',
  'pay.timeHours': 'Timer',
  'pay.timeNote': 'Notat',
  'pay.timeNotePh': 'Hvad arbejdede du med?',
  'pay.timePickProject': 'Vælg projekt …',
  'pay.timePickActivity': 'Vælg aktivitet …',
  'pay.timeSum': 'I alt',
  'pay.timeSaved': 'Registreringen er gemt',
  'pay.timeDeleted': 'Registreringen er slettet',
  'pay.timeFailed': 'Kunne ikke gemme registreringen.',
  'pay.timeLocked': 'Tidsregistreringen for denne periode er markeret som færdig.',
  'pay.timeLockedThrough': 'Tidsregistreringen er markeret som færdig til og med {date}.',
  'pay.timeEmptyTitle': 'Ingen timer denne uge',
  'pay.timeEmpty': 'Tryk på »Registrer timer« for at tilføje den første.',
  'pay.timeNoProjectsTitle': 'Ingen projekter',
  'pay.timeNoProjects': 'Din arbejdsgiver har endnu ikke oprettet projekter, du kan registrere timer på.',
  'pay.timePrevWeek': 'Forrige uge',
  'pay.timeNextWeek': 'Næste uge',
  'pay.myEmployeePage': 'Min medarbejderside',
  'pay.myEmployeePageHelp': 'Din side som medarbejder hos en arbejdsgiver — adskilt fra eventuelle regnskaber, du fører. Her ser du dine lønsedler og registrerer udlæg og rejser, du skal have refunderet. Øverst skifter du mellem de arbejdsgivere, du er ansat hos.',
  'pay.employer': 'Arbejdsgiver',
  'pay.employerHelp': 'Den arbejdsgiver, denne side gælder. Er du ansat flere steder, skifter du her — så viser lønsedler, udlæg og rejser tallene for den valgte arbejdsgiver.',
  'pay.payslipsHelp': 'Lønsedlerne fra arbejdsgiveren — en oversigt over løn, skattetræk og udbetalt beløb for hver lønkørsel. Tryk for at åbne.',
  'pay.expensesHelp': 'Udlæg, du har betalt af egen lomme og skal have refunderet — f.eks. en kvittering for noget købt privat. Send dem til godkendelse, så refunderes de via lønnen.',
  'pay.travelHelp': 'Rejseafregninger med kørselsgodtgørelse, diæter og udlæg knyttet til en rejse. Send dem til godkendelse og refusion via lønnen.',
  'pay.registerExpenseHelp': 'Registrer et nyt udlæg, du har betalt — upload kvitteringen, angiv beløb, og hvad det vedrører. Sendes til arbejdsgiveren til godkendelse og refusion.',
  'pay.registerTravelHelp': 'Registrer en rejseafregning — køreture (kilometergodtgørelse), diæter og udlæg knyttet til rejsen. Sendes til arbejdsgiveren til godkendelse.',
  'pay.employmentStatusLabel.active': 'Aktivt ansættelsesforhold',
  'pay.employmentStatusLabel.ended': 'Fratrådt',
  'pay.employmentStatusLabel.future': 'Starter senere',
  'pay.taxRuleNotSupported': 'understøttes ikke endnu',
  'pay.taxRuleNotSupportedHint': 'Plumme beregner kun almindelig skat og arbejdsgiverafgift. En lønkørsel med denne medarbejder kan ikke godkendes – kør lønnen for medarbejderen uden for Plumme.',
  'pay.portalEmploymentEnded': 'Dit ansættelsesforhold er ophørt. Du kan stadig se dine lønsedler, men ikke indsende nye udlæg, rejser eller timer. Kontakt arbejdsgiveren, hvis du har et udlæg, der skal refunderes.',
  'err.employeePortal.employmentEnded': 'Ansættelsesforholdet er ophørt, og medarbejderportalen er nu skrivebeskyttet. Bed arbejdsgiveren registrere udlægget.',
  'pay.foreignAmount.label': 'Beløb betalt i NOK',
  'pay.foreignAmount.hint': 'Kvitteringen er i {currency}. Angiv, hvad du faktisk betalte i norske kroner, for eksempel fra kontoudskriften. Udlægget kan ikke godkendes uden NOK-beløb.',
  'pay.foreignAmount.rateHint': 'Svarer til kursen {rate} NOK pr. {currency}.',
  'pay.foreignAmount.missing': 'NOK-beløb mangler',
  'pay.foreignAmount.missingOnApproval': 'Udlægget »{description}« er i {currency} og mangler NOK-beløb. Rediger linjen, og indtast det beløb, der faktisk blev betalt i NOK, før du godkender.',
  'err.payroll.foreignAmountMissingNok': 'Et udlæg i udenlandsk valuta mangler NOK-beløb. Indtast det beløb, der faktisk blev betalt i NOK, før du godkender.',
  'pay.tabSalaryTax': 'Løn & skat',
  'pay.tabPayslipsExpenses': 'Lønsedler & udlæg',
  'pay.taxRuleOption.ordinary': 'Almindelige',
  'pay.taxRuleOption.svalbard': 'Svalbard',
  'pay.taxRuleOption.janMayen': 'Jan Mayen og bilandene',
  'pay.taxRuleOption.seafarerDeduction': 'Særligt fradrag for søfolk',
  'pay.taxRuleOption.charity': 'Velgørende eller almennyttig organisation',
  'pay.taxRuleOption.netPay': 'Nettoløn',
  'pay.taxRuleOption.netPaySeafarer': 'Nettoløn for søfolk',
  'pay.taxRuleOption.pensionSourceTax': 'Kildeskat på pensioner',
  'pay.taxRuleOption.nanny': 'Dagplejer i barnets hjem',
  'pay.taxRuleOption.homeWork': 'Lønarbejde i hjemmet',
  'pay.taxRuleOption.taxFreeOrg': 'Skattefri organisation',
  'pay.employmentTypeOption.ordinary': 'Almindeligt ansættelsesforhold',
  'pay.employmentTypeOption.maritime': 'Maritimt ansættelsesforhold',
  'pay.employmentTypeOption.freelance': 'Freelancer, opdragstager eller honorarmodtager',
  'pay.employmentTypeOption.pension': 'Pension eller andet trækpligtigt forhold',
  'pay.employmentTypeOption.notEmployed': 'Ikke ansat',
  'pay.employmentTypeOption.simplifiedPrivate': 'Forenklet afregningsordning, privat arbejdsgiver',
  'pay.employmentTypeOption.simplifiedCharity': 'Forenklet afregningsordning, velgørende organisation',
  'pay.employmentTypeOption.foreignService': 'Udenlandsk tjenesteforhold',
  'pay.employmentTypeOption.boardFee': 'Bestyrelseshonorar',
  'pay.employmentFormOption.permanent': 'Fast',
  'pay.employmentFormOption.temporary': 'Midlertidig',
  'pay.employmentFormOption.temporarySubstitute': 'Midlertidigt ansat som tilkaldevikar',
  'pay.employmentFormOption.permanentHiredOut': 'Fastansættelse og udlejet',
  'pay.employmentFormOption.temporaryHiredOut': 'Midlertidig ansættelse og udlejet',
  'pay.shift.offshore': 'Offshore',
  'pay.hourlyOvertimePay': 'Timeløn - overarbejde',
  'pay.fixedLine': 'Fast linje',
  'pay.portalAccess.notInvited': 'Ikke givet adgang',
  'pay.portalAccess.active': 'Aktiv adgang',
  'pay.portalAccess.revoked': 'Adgang trukket tilbage',
  'pay.documentUploaded': 'Dokument uploadet.',
  'pay.documentsUploaded': 'Dokumenter uploadet.',
  'pay.documentDeleted': 'Dokument slettet.',
  'pay.amountRequired': 'Indtast et beløb.',
  'pay.fixedLineDeleted': 'Fast lønlinje slettet.',
  'pay.fixedLineDeleteFailed': 'Kunne ikke slette fast lønlinje.',
  'pay.emailRequiredFirst': 'Indtast først en gyldig e-mailadresse på medarbejderprofilen.',
  'pay.portalAccessSent': 'Adgang sendt til {email}.',
  'pay.portalAccessRevokedToast': 'Adgang trukket tilbage.',
  'pay.portalAccessSendFailed': 'Kunne ikke sende adgang.',
  'pay.portalAccessRevokeFailed': 'Kunne ikke trække adgang tilbage.',
  'pay.saveEmployeeFailed': 'Kunne ikke gemme medarbejder.',
  'pay.confirmDeleteDocument': 'Slet dokumentet "{name}"?',
  'pay.confirmDeleteFixedLine': 'Slet fast lønlinje "{line}" for {name}?',
  'pay.confirmRevokePortalAccess': 'Træk adgang til medarbejderportalen tilbage for {name}?',
  'pay.taxCardValidUntil': 'Skattekort gyldigt til',
  'pay.leaveOfAbsence': 'Orlov',
  'pay.noLeaveRegistered': 'Ingen registreret',
  'pay.loginEmail': 'E-mail til login',
  'pay.lastSent': 'Senest sendt',
  'pay.revoked': 'Trukket tilbage',
  'pay.bankAccount': 'Bankkonto',
  'pay.hoursInFullWeek': 'Timer i en fuld uge',
  'pay.uploading': 'Uploader ...',
  'pay.newDocument': 'Nyt dokument',
  'pay.resendAccess': 'Send adgang igen',
  'pay.grantEmployeeAccess': 'Giv medarbejder adgang',
  'pay.revoking': 'Trækker tilbage ...',
  'pay.revokeAccess': 'Træk adgang tilbage',
  'pay.portalAccessExplain': 'Adgangen knyttes til medarbejderens e-mail og medarbejder-ID. Selve medarbejderfladen bruger denne tilknytning, når portallogin bliver tilsluttet.',
  'pay.useStandardHolidayRate': 'Brug standardsatsen fra lønindstillingerne ({rate} %)',
  'pay.priorYearSalaryHeading': 'Løn i {year}',
  'pay.payrollDataHidden': 'Løndata er skjult for denne adgang',
  'pay.payrollDataHiddenBody': 'Ansatte, faste lønlinjer og lønudbetalinger ligger i et separat personaledokument. Din rolle for denne klient er {role}, og appen fik ikke lov til at læse personaledokumentet. Rejser og udlæg, der er bogført i regnskabet, kan derfor stadig vises.',
  'pay.unknownAccess': 'ukendt adgang',
  'pay.readAccess': 'Læseadgang',
  'pay.registerFirstEmployee': 'Registrer den første ansatte for at bruge lønkørsel, skattekort og a-melding.',
  'pay.mainEmployerOption': 'Hovedarbejdsgiver',
  'pay.secondaryEmployerOption': 'Bijob',
  'pay.documentsCount': '{count} dokumenter',
  'pay.noDocumentsUploaded': 'Ingen uploadede dokumenter',
  'pay.cannotOpenDocument': 'Kunne ikke åbne dokumentet.',
  'pay.cannotDownloadDocument': 'Kunne ikke downloade dokumentet.',
  'pay.endEmployment': 'Afslut ansættelsesforhold',
  'pay.reopenEmployment': 'Genåbn ansættelsesforhold',
  'pay.earnedHolidayPayInYear': 'Optjente feriepenge i {year}',
  'pay.holidayPayNotPaidBeforeStartHint': 'Feriepenge, der ikke er blevet udbetalt før startdatoen i Plumme.',
  'pay.earnedTaxablePayInYear': 'Optjent løn (skattegrundlag) i {year}',
  'pay.grossPayNotInPlummeHint': 'Bruttoløn udbetalt fra virksomheden i {year}, som ikke er bogført i Plumme.',
  'pay.withheldTaxInYear': 'Indeholdt skat i {year}',
  'pay.priorYearAmountWarning': 'Beløb for {year} skal kun udfyldes, hvis de ikke indgår i andre lønudbetalinger, der er bogført i Plumme.',
  'pay.agreedSalaryInternalNote': 'Aftalt løn bruges kun som intern dokumentation. Lønkørslen styres af faste eller manuelle lønlinjer.',
  'pay.estimatedAnnualSalaryFrom': 'Estimeret årsløn beregnes ud fra {summary}',
  'pay.fixedLinesRegisteredCount': '{count} registreret',
  'pay.fixedLinesOnEmployee': 'Faste lønlinjer, der ligger på denne ansatte.',
  'pay.noFixedLinesRegistered': 'Der er ikke registreret nogen faste linjer.',
  'pay.internalDocumentationNote': 'Dette er intern dokumentation. Lønkørslen bruger faste lønlinjer eller manuelle linjer på lønudbetalingen.',
  'pay.noAgreedSalaryBody': 'Angiv årsløn eller timeløn for at se estimeret årlig omkostning, feriepenge, arbejdsgiverafgift og skat.',
  'pay.selectOccupationCode': 'Vælg stillingskode ...',
  'pay.noOccupationCodeMatch': 'Ingen resultater for "{query}".',
  'pay.editEmployeeTitle': 'Rediger ansat',
  'pay.newEmployeeTitle': 'Ny ansat',
  'err.nativeValidation.payrollManualAMelding.1': 'Manuel registrering af a-melding kræver norsk lønkørsel.',
  'err.nativeValidation.payrollManualAMelding.2': 'Manuel indsendelse skal bekræftes udtrykkeligt.',
  'err.nativeValidation.payrollManualAMelding.3': 'Gyldig rapporteringsperiode, indsendelsesdato og manuel reference skal angives.',
  'err.nativeValidation.payrollManualAMelding.4': 'Indsendelsesdatoen skal ligge efter rapporteringsmåneden og kan ikke ligge i fremtiden.',
  'err.nativeValidation.payrollManualAMelding.5': 'Bekræft præcist de bogførte lønkørsler i rapporteringsmåneden.',
  'err.nativeValidation.payrollManualAMelding.6': 'Den manuelle rapportreference er allerede registreret for denne måned.',
  'err.nativeValidation.pensionPremiumMutation.1': 'Pensionsbetaling kræver norsk regnskab i NOK.',
  'err.nativeValidation.pensionPremiumMutation.2': 'Gyldigt pensionsbilag og dato skal angives.',
  'err.nativeValidation.pensionPremiumMutation.3': 'Denne pensionsbetaling understøtter kun de kontrollerede satser for 2026 i zone I.',
  'err.nativeValidation.pensionPremiumMutation.4': 'Pensionsbetaling bruger NOK-bankkonto 1920.',
  'err.nativeValidation.pensionPremiumMutation.5': 'Pensionsbeløb skal være endelige, ikke-negative tal med hele øre.',
  'err.nativeValidation.pensionPremiumMutation.6': 'Pensionsbetalingen kan ikke registreres før regnskabsdatoen.',
  'err.nativeValidation.pensionPremiumMutation.7': 'Bilagsidentiteten for pensionen er allerede reserveret.',
  'err.nativeValidation.pensionPremiumMutation.8': 'Nummereringshistorikken for pension er ugyldig.',
});
